const translations = {
  "en": {
    "Added! Ed is now tracking this for you.": "Added! Ed is now tracking this for you."
  },
  "zh-tw": {
    "Added! Ed is now tracking this for you.": "已新增！Ed 現在為你追蹤此標的。"
  }
};

export default translations;
